export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Men\u00fc",
    "What are you looking for?": "Was suchst du?",
    "back": "zur\u00fcck",
    "Filtering": "Filtern",
    "Clear all": "Alles l\u00f6schen",
    "Show more": "Mehr anzeigen",
    "Show less": "Weniger anzeigen",
    "Price": "Preis",
    "to": "bis",
    "Enter a correct value": "Geben Sie einen korrekten Wert ein",
    "Popularity": "Beliebtheit",
    "Newest": "Neueste",
    "Yes": "Ja",
    "No": "Nein",
    "Name (A-Z)": "Name (A-Z)",
    "Name (Z-A)": "Name (Z-A)",
    "Price (Ascending)": "Preis (Aufsteigend)",
    "Price (Descending)": "Preis (Absteigend)",
    "Categories": "Kategorien",
    "Apply": "Anwenden",
    "No products were found in this category.": "Es wurden keine Produkte in dieser Kategorie gefunden.",
    "Discount valid from {start} to {end}": "Rabatt g\u00fcltig von {start} bis {end}",
    "More info": "Mehr Info",
    "Subscribe to our newsletter": "Abonniere unseren Newsletter",
    "Yes i subscribe!": "Ja, ich abonniere!",
    "Follow us": "Folge uns",
    "Compare products": "Produkte vergleichen",
    "Compare": "Vergleichen",
    "Edit": "Bearbeiten",
    "Change password": "Passwort \u00e4ndern",
    "Contact information": "Kontaktinformationen",
    "Personal information": "Pers\u00f6nliche Informationen",
    "Opening Hours": "\u00d6ffnungszeiten",
    "Monday": "Montag",
    "Tuesday": "Dienstag",
    "Wednesday": "Mittwoch",
    "Thursday": "Donnerstag",
    "Friday": "Freitag",
    "Saturday": "Samstag",
    "Sunday": "Sonntag",
    "Coffee corner": "Kaffee-Ecke",
    "Extra information": "Zus\u00e4tzliche Informationen",
    "Phone": "Telefon",
    "Special opening hours": "Sonder\u00f6ffnungszeiten",
    "No special opening hours": "Keine Sonder\u00f6ffnungszeiten",
    "Subject to change. Deviating opening hours (holidays etc.) are listed below under Special opening hours.": "\u00c4nderungen vorbehalten. Abweichende \u00d6ffnungszeiten (Feiertage etc.) sind unten unter Sonder\u00f6ffnungszeiten aufgef\u00fchrt.",
    "E-mailadress": "E-Mail-Adresse",
    "Subject": "Betreff",
    "Select a subject": "W\u00e4hlen Sie ein Thema",
    "Store": "Gesch\u00e4ft",
    "Stores": "Gesch\u00e4fte",
    "No specific store": "Kein bestimmtes Gesch\u00e4ft",
    "Question": "Frage",
    "Fields marked with * are required.": "Felder, die mit * markiert sind, sind erforderlich.",
    "Submit contact request": "Kontaktanfrage senden",
    "Addition": "Zusatz",
    "Declaration of conformity": "Konformit\u00e4tserkl\u00e4rung",
    "Download": "Herunterladen",
    "House number": "Hausnummer",
    "First name": "Vorname",
    "Last name": "Nachname",
    "Phone number": "Telefonnummer",
    "The {_field_} field must be selected.": "Das Feld {_field_} muss ausgew\u00e4hlt werden.",
    "The subject field must be selected.": "Das Betreff-Feld muss ausgew\u00e4hlt werden.",
    "Your message has been sent": "Ihre Nachricht wurde gesendet",
    "In Stock in {count} store(s)": "Auf Lager in {count} Gesch\u00e4ft(en)",
    "I accept": "Ich akzeptiere",
    "Valid until": "G\u00fcltig bis",
    "Sort by": "Sortieren nach",
    "Show store": "Gesch\u00e4ft anzeigen",
    "Chosen filters": "Ausgew\u00e4hlte Filter",
    "Show {totalItems} results": "Zeige {totalItems} Ergebnisse",
    "Sidebar menu - Quick Access": "Seitenmen\u00fc - Schneller Zugriff",
    "Quick access to": "Schnellzugriff auf",
    "Call": "Anrufen",
    "Atmospheric image of": "Stimmungsbild von",
    "In stock": "Auf Lager",
    "Specifications": "Spezifikationen",
    "There was a problem with the subscription: This email address is already subscribed.": "Es gab ein Problem mit dem Abonnement: Diese E-Mail-Adresse ist bereits abonniert.",
    "Thank you for your subscription.": "Danke f\u00fcr Ihr Abonnement.",
    "Choose your {option}": "W\u00e4hlen Sie Ihre {option}",
    "Other variants": "Andere Varianten",
    "Remove from wishlist": "Von der Wunschliste entfernen",
    "Select an option to show stock information": "W\u00e4hlen Sie eine Option, um Lagerinformationen anzuzeigen",
    "Promotion till": "Aktion g\u00fcltig bis",
    "Out of stock": "Nicht auf Lager",
    "In stock in {count} store(s)": "Auf Lager in {count} Gesch\u00e4ft(en)",
    "Other Variants": "Andere Varianten",
    "{count} items in stock": "{count} Artikel auf Lager",
    "Less then {count} items in stock": "Weniger als {count} Artikel auf Lager",
    "Others also viewed": "Andere haben auch angesehen",
    "Frequently asked questions": "H\u00e4ufig gestellte Fragen",
    "Most asked questions": "Meistgestellte Fragen",
    "Where are you searching for?": "Wonach suchen Sie?",
    "Search on subject": "Nach Thema suchen",
    "This is what we found": "Das haben wir gefunden",
    "Product description": "Produktbeschreibung",
    "Privacy checkbox is required": "Das Datenschutz-Kontrollk\u00e4stchen ist erforderlich",
    "We didn't found any results": "Wir haben keine Ergebnisse gefunden",
    "Sorry, we couldn't find anything based on your search. Please change your search request, or search by category for your question.": "Entschuldigung, wir konnten nichts basierend auf Ihrer Suche finden. Bitte \u00e4ndern Sie Ihre Suchanfrage oder suchen Sie nach Kategorie f\u00fcr Ihre Frage.",
    "Contact": "Kontakt",
    "Complaints? We\u2019re here to help!": "Beschwerden? Wir sind hier, um zu helfen!",
    "We\u2019re sorry to hear that you have a complaint. We will do our best to resolve this as soon as possible.": "Es tut uns leid zu h\u00f6ren, dass Sie eine Beschwerde haben. Wir werden unser Bestes tun, um dies so schnell wie m\u00f6glich zu l\u00f6sen.",
    "Can we help you with something?": "K\u00f6nnen wir Ihnen bei etwas helfen?",
    "Do you need a helping hand? We\u2019re here to help you with any questions you may have.": "Brauchen Sie eine helfende Hand? Wir sind hier, um Ihnen bei allen Fragen zu helfen, die Sie haben k\u00f6nnten.",
    "Drag your photo here or use the upload button": "Ziehen Sie Ihr Foto hierher oder verwenden Sie die Upload-Schaltfl\u00e4che",
    "SVG, PNG, JPG of GIF (max. 200mb)": "SVG, PNG, JPG oder GIF (max. 200mb)",
    "Uploaden": "Hochladen",
    "Drop your foto here": "Lassen Sie Ihr Foto hier fallen",
    "My favorites": "Meine Favoriten",
    "You have no products in your favorites yet.": "Sie haben noch keine Produkte in Ihren Favoriten.",
    "Low stock": "Achtung: Sehr begrenzter Vorrat - Verf\u00fcgbarkeit im Gesch\u00e4ft kann nicht garantiert werden.",
    "Store stock": "Lagerbestand",
    "Put on wishlist": "Auf die Wunschliste setzen",
    "Read more": "Mehr lesen",
    "Search suggestions": "Suchvorschl\u00e4ge",
    "Popular products": "Beliebte Produkte",
    "Price descending": "Preis (Absteigend)",
    "Price ascending": "Preis (Aufsteigend)"
}